import { isEmpty } from 'lodash'
import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Dropdown from 'components/v2/Dropdown'
import { DotsIcon } from 'components/Icons'
import IconButton from 'components/v2/IconButton'
import List from 'components/v2/List'
import { PanelOpenIcon } from 'components/Icons/PanelOpenIcon'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const TogglePanelWrapper = styled.div`
  margin: -8px 0;
`

const PanelClosedIcon = styled(PanelOpenIcon)`
  transform: rotate(180deg);
`

interface IRoutesListActionsProps {
  visibleRoutesIds: string[]
  setVisibleRoutesIds: (ids: string[]) => void
  allRoutesIds: string[]
  isRoutesListExpanded: boolean
  setIsRoutesListExpanded: (isExpanded: boolean) => void
}

export const RoutesListActions = ({
  visibleRoutesIds,
  setVisibleRoutesIds,
  allRoutesIds,
  isRoutesListExpanded,
  setIsRoutesListExpanded
}: IRoutesListActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  return (
    <Container>
      <TogglePanelWrapper onClick={(): void => setIsRoutesListExpanded(!isRoutesListExpanded)}>
        <IconButton icon={isRoutesListExpanded ? <PanelClosedIcon /> : <PanelOpenIcon />} noBorder smallPadding />
      </TogglePanelWrapper>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator right>
          <List.Container>
            <List.Item
              action
              onClick={(): void => setVisibleRoutesIds(allRoutesIds)}
              disabled={visibleRoutesIds.length === allRoutesIds.length}
            >
              <FormattedMessage id="routePlanning.list.actions.viewAll" defaultMessage="View All" />
            </List.Item>
            <List.Item action onClick={(): void => setVisibleRoutesIds([])} disabled={isEmpty(visibleRoutesIds)}>
              <FormattedMessage id="routePlanning.list.actions.hideAll" defaultMessage="Hide All" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </Container>
  )
}
